import { DateTime } from "luxon"

export const startOfTotoSelection = DateTime.now().plus({ quarter: 1 }).startOf("quarter")
export const canPickArticlesNow =
  process.env.REACT_APP_FF_PICK_TOTO_ARTICLE === "true" &&
  DateTime.now() < startOfTotoSelection &&
  DateTime.now() >= startOfTotoSelection.minus({ days: 45 })
